import axios, {AxiosRequestConfig} from "axios";

import {getBaseUrl} from "./api";

const apiUrl = getBaseUrl();

const axios_instance = axios.create({
  baseURL: `${apiUrl}`,
  withCredentials: process.env.NODE_ENV !== "development",
});

export const axiosInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const source = axios.CancelToken.source();
  const promise = axios_instance({...config, cancelToken: source.token}).then(
    ({data}) => data,
  );

  return promise;
};
